import { Menu } from './menu.model';
import { NavigationItem } from '../../../models/navigation-item.model';

export interface ApplicationBar {
  title: string;
  items: NavigationItem[];
  menu: Menu;
  home: { url: string };
}
